// --- Code generated by protoc-gen-rg. DO NOT EDIT. --- //
import * as t from 'runtypes';
import { left, right, Either } from 'fp-ts/lib/Either';
import {
  FetcherContext,
  Error as APIErrorResponse,
} from '@rogu/fetch/dist/base';
import { ADT } from '@rogu/adt';

import fetcher from '@/shared/fetcher';

export type DecodeError = t.ValidationError;

export type { APIErrorResponse };

export type ErrorResponse = DecodeError | APIErrorResponse | Error | undefined;

export const DeactivationTypeSchema = t.Union(
  t.Literal('unknown_deactivation_type'),
  t.Literal('soft_delete'),
  t.Literal('anonymize'),
  t.Literal('hard_delete'),
);

export type DeactivationType = t.Static<typeof DeactivationTypeSchema>;

export const SocialMediaTypeEnumSchema = t.Union(
  t.Literal('Unknown'),
  t.Literal('WhatsApp'),
);

export type SocialMediaTypeEnum = t.Static<typeof SocialMediaTypeEnumSchema>;

export const UserGenderSchema = t.Union(
  t.Literal('unknownUserGender'),
  t.Literal('F'),
  t.Literal('M'),
);

export type UserGender = t.Static<typeof UserGenderSchema>;

export const UserRegistrationSourceSchema = t.Union(
  t.Literal('unknownRegistrationSource'),
  t.Literal('facebook'),
  t.Literal('google'),
  t.Literal('email'),
  t.Literal('apple'),
);

export type UserRegistrationSource = t.Static<
  typeof UserRegistrationSourceSchema
>;

export const UserRoleSchema = t.Union(
  t.Literal('unknownUserRole'),
  t.Literal('teacher'),
  t.Literal('student'),
  t.Literal('admin'),
  t.Literal('parent'),
  t.Literal('employee'),
  t.Literal('company'),
  t.Literal('department'),
  t.Literal('skillAcademyUser'),
  t.Literal('instructor'),
  t.Literal('unclaimed'),
);

export type UserRole = t.Static<typeof UserRoleSchema>;

export const UserYesNoSchema = t.Union(
  t.Literal('unknownUserYesNo'),
  t.Literal('y'),
  t.Literal('n'),
);

export type UserYesNo = t.Static<typeof UserYesNoSchema>;

export const VerifyPhoneNumberTypeSchema = t.Union(
  t.Literal('unknown'),
  t.Literal('requestWaOtp'),
  t.Literal('requestSmsOtp'),
);

export type VerifyPhoneNumberType = t.Static<
  typeof VerifyPhoneNumberTypeSchema
>;

export const GetUserDataByTokenResponseSchema = t.Record({
  name: t.String,
  username: t.String,
  shortname: t.String,
  email: t.String,
  role: UserRoleSchema,
  cellphone_number: t.String,
  unique_order_code: t.String,
  gender: t.String.Or(t.Null).Or(t.Undefined),
  birth_date: t.String.Or(t.Null).Or(t.Undefined),
  birth_place: t.String.Or(t.Null).Or(t.Undefined),
  parental_code: t.String.Or(t.Null).Or(t.Undefined),
  profile_pic_full_domain: t.String.Or(t.Null).Or(t.Undefined),
  profile_pic: t.String.Or(t.Null).Or(t.Undefined),
  activation_code: t.String.Or(t.Null).Or(t.Undefined),
  is_active: t.String.Or(t.Null).Or(t.Undefined),
  created_at: t.String.Or(t.Null).Or(t.Undefined),
  qiscus_email: t.String.Or(t.Null).Or(t.Undefined),
  profpic_without_key: t.String.Or(t.Null).Or(t.Undefined),
  grade_serial: t.String.Or(t.Null).Or(t.Undefined),
  curriculum_serial: t.String.Or(t.Null).Or(t.Undefined),
  referral_code: t.String.Or(t.Null).Or(t.Undefined),
  overall_rating: t.Number.Or(t.Null).Or(t.Undefined),
  long_about_me: t.String.Or(t.Null).Or(t.Undefined),
  short_about_me: t.String.Or(t.Null).Or(t.Undefined),
  bank_account_name: t.String.Or(t.Null).Or(t.Undefined),
  rating_summary: t.Number.Or(t.Null).Or(t.Undefined),
  teacher_teaching_preference: t.String.Or(t.Null).Or(t.Undefined),
  is_verified: t.Boolean.Or(t.Null).Or(t.Undefined),
  office_phone_number: t.String.Or(t.Null).Or(t.Undefined),
  cellphone_number_2: t.String.Or(t.Null).Or(t.Undefined),
  credit_balance: t.Number.Or(t.Null).Or(t.Undefined),
  school_name: t.String.Or(t.Null).Or(t.Undefined),
  degree: t.String.Or(t.Null).Or(t.Undefined),
  lesson_name: t.String.Or(t.Null).Or(t.Undefined),
  is_parent: t.Number.Or(t.Null).Or(t.Undefined),
  last_url: t.String.Or(t.Null).Or(t.Undefined),
  admin_code: t.String.Or(t.Null).Or(t.Undefined),
  domicile_province: t.Number.Or(t.Null).Or(t.Undefined),
  domicile_province_name: t.String.Or(t.Null).Or(t.Undefined),
  domicile_city: t.Number.Or(t.Null).Or(t.Undefined),
  domicile_city_name: t.String.Or(t.Null).Or(t.Undefined),
  domicile_kecamatan: t.Number.Or(t.Null).Or(t.Undefined),
  domicile_postal_code: t.String.Or(t.Null).Or(t.Undefined),
  domicile_address: t.String.Or(t.Null).Or(t.Undefined),
  ktp_province: t.Number.Or(t.Null).Or(t.Undefined),
  ktp_province_name: t.String.Or(t.Null).Or(t.Undefined),
  ktp_city: t.Number.Or(t.Null).Or(t.Undefined),
  ktp_city_name: t.String.Or(t.Null).Or(t.Undefined),
  ktp_kecamatan: t.Number.Or(t.Null).Or(t.Undefined),
  ktp_postal_code: t.String.Or(t.Null).Or(t.Undefined),
  ktp_address: t.String.Or(t.Null).Or(t.Undefined),
  nik_no: t.String.Or(t.Null).Or(t.Undefined),
  nik_image: t.String.Or(t.Null).Or(t.Undefined),
  npwp_no: t.String.Or(t.Null).Or(t.Undefined),
  npwp_image: t.String.Or(t.Null).Or(t.Undefined),
  bank_id: t.Number.Or(t.Null).Or(t.Undefined),
  bank_name: t.String.Or(t.Null).Or(t.Undefined),
  bank_account_no: t.String.Or(t.Null).Or(t.Undefined),
  showParentalForm: t.Boolean.Or(t.Null).Or(t.Undefined),
  parent_name: t.String.Or(t.Null).Or(t.Undefined),
  parent_cellphone_number: t.String.Or(t.Null).Or(t.Undefined),
  email_updated_at: t.String.Or(t.Null).Or(t.Undefined),
  is_email_verified: t.Boolean.Or(t.Null).Or(t.Undefined),
  registration_source: UserRegistrationSourceSchema.Or(t.Null).Or(t.Undefined),
  curriculum_name: t.String.Or(t.Null).Or(t.Undefined),
  subscribe: t.Number.Or(t.Null).Or(t.Undefined),
});

export type GetUserDataByTokenResponse = t.Static<
  typeof GetUserDataByTokenResponseSchema
>;

export type GetUserDataByTokenError = ADT<{
  DECODE_ERROR: { message: string };
  UNKNOWN_ERROR: { error?: ErrorResponse };
  SERVER_ERROR: { error: APIErrorResponse };
}>;

export function getUserDataByTokenExn(context?: FetcherContext) {
  return new Promise<Array<GetUserDataByTokenResponse>>((resolve, reject) =>
    fetcher({
      ...context,
      url: `/api/v3/user`,
      method: 'get',
      withAuth: true,
    })
      .then((data) => {
        return t.Array(GetUserDataByTokenResponseSchema).check(data);
      })
      .then((dataOk) => {
        resolve(dataOk);
      })
      .catch((error) => {
        if (error instanceof t.ValidationError) {
          return reject({ _tag: 'DECODE_ERROR', message: error.message });
        } else if (error && 'errorCode' in error) {
          switch (error.errorCode) {
            default:
              return reject({
                _tag: 'SERVER_ERROR',
                error,
              });
          }
        }
        return reject({ _tag: 'UNKNOWN_ERROR', error });
      }),
  );
}

export function getUserDataByToken(context?: FetcherContext) {
  return new Promise<
    Either<GetUserDataByTokenError, GetUserDataByTokenResponse>
  >((resolve) =>
    fetcher({
      ...context,
      url: `/api/v3/user`,
      method: 'get',
      withAuth: true,
    })
      .then((data) => {
        return GetUserDataByTokenResponseSchema.check(data);
      })
      .then((dataOk) => {
        resolve(right(dataOk));
      })
      .catch((error) => {
        if (error instanceof t.ValidationError) {
          return resolve(
            left({ _tag: 'DECODE_ERROR', message: error.message }),
          );
        } else if (error && 'errorCode' in error) {
          switch (error.errorCode) {
            default:
              return resolve(left({ _tag: 'SERVER_ERROR', error }));
          }
        }
        return resolve(left({ _tag: 'UNKNOWN_ERROR', error }));
      }),
  );
}
